import { FC } from 'react';
import { Game } from '../../games.model';
import { GameCard } from '../../GameCard';
import { GameCardContainerType } from '../../GameCard/GameCard.types';
import { BaseLayoutProps } from './GameGridUtils';

interface GameCardRendererProps {
  game: Game;
  containerType: GameCardContainerType;
  cardKey: string;
  layoutProps: Omit<BaseLayoutProps, 'games' | 'getCompositeKey'>;
}

export const renderGameCard = (
  game: Game,
  containerType: GameCardContainerType,
  key: string,
  props: Omit<BaseLayoutProps, 'games' | 'getCompositeKey'>
): JSX.Element => (
  <GameCard
    key={key}
    game={game}
    containerType={containerType}
    disabled={props.disabled ?? false}
    showGameName={props.showGameName ?? true}
    showDisplayName={false}
    fallbackImageAltText={props.fallbackImageAltText ?? ''}
    fallbackImageUrl={props.fallbackImageUrl ?? ''}
    onViewGameInfo={(): void => props.onViewGameInfo?.(game)}
    onPlayDemo={(): void => props.onPlayDemo?.(game)}
    onPlayGame={(): void => props.onPlayGame?.(game)}
    containerElementWidth={props.containerElementWidth}
    gameUrl=""
  />
);

export const GameCardRenderer: FC<GameCardRendererProps> = ({ game, containerType, cardKey, layoutProps }) => {
  return renderGameCard(game, containerType, cardKey, layoutProps);
};
